export default {
  props: {
    isOpen: {
      type    : Boolean,
      default : false
    },
    marketplaceAuthor: {
      type    : String,
      default : null
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirmEdit() {
      this.$emit('confirmEdit');
    }
  }
};
